import * as Safe from "safe-portals";

export type ShareType = "native" | "facebook" | "twitter" | "whatsapp";

export const ShareTypeSerializer: Safe.Type<ShareType> = Safe.oneOf("facebook", "twitter", "whatsapp", "native");

export type Stats = Safe.TypeIn<typeof StatsSerializer>;

export const StatsSerializer = Safe.obj({
  facebook: Safe.int,
  whatsapp: Safe.int,
  twitter: Safe.int,
  native: Safe.int,
});
